var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 142,
    viewBox: "0 0 143 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.896 70.9999C140.896 109.435 109.751 140.58 71.3163 140.58C32.8817 140.58 1.73633 109.435 1.73633 70.9999C1.73633 32.5653 32.8817 1.41992 71.3163 1.41992C109.751 1.41992 140.896 32.5653 140.896 70.9999Z",
    fill: "url(#paint0_linear_1545_9267)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.989 74.3284C109.363 73.7016 108.625 73.3697 107.777 73.3697H96.6794V58.843L105.233 50.2524C105.86 49.6256 106.192 48.8882 106.192 48.0402C106.192 47.1922 105.86 46.4548 105.233 45.828C104.606 45.2012 103.869 44.8694 103.021 44.8694C102.173 44.8694 101.436 45.2012 100.809 45.828L92.255 54.3818H50.4078L41.854 45.7911C41.2272 45.1643 40.4899 44.8325 39.6418 44.8325C38.7938 44.8325 38.0564 45.1643 37.4297 45.7911C36.8029 46.4179 36.471 47.1553 36.471 48.0033C36.471 48.8513 36.8029 49.5887 37.4297 50.2155L45.9466 58.843V73.4066H34.8856C34.0376 73.4066 33.3002 73.7384 32.6735 74.3652C32.0467 74.992 31.7148 75.7294 31.7148 76.5774C31.7148 77.4254 32.0467 78.1628 32.6735 78.7896C33.3002 79.4164 34.0376 79.7482 34.8856 79.7482H45.9835C45.9835 85.0206 46.9421 89.5556 48.8593 93.3163L38.8676 104.562C38.3145 105.225 38.0564 106 38.0933 106.848C38.1302 107.732 38.4989 108.47 39.1257 109.06C39.7525 109.576 40.453 109.871 41.2641 109.871C42.1859 109.871 42.997 109.539 43.6238 108.838L52.6938 98.5887L53.4311 99.2892C53.9105 99.7316 54.611 100.248 55.5696 100.911C56.5282 101.538 57.6343 102.202 58.851 102.829C60.0677 103.455 61.5056 104.009 63.1648 104.451C64.8239 104.893 66.5199 105.115 68.1791 105.115V60.7234H74.5207V105.078C76.1061 105.078 77.6915 104.857 79.3137 104.451C80.936 104.009 82.3002 103.529 83.3694 103.013C84.4755 102.497 85.5447 101.87 86.5771 101.206C87.6463 100.543 88.31 100.063 88.6418 99.8054C88.9736 99.5473 89.2317 99.3261 89.3792 99.1786L99.1866 108.949C99.7765 109.576 100.514 109.908 101.399 109.908C102.284 109.908 103.021 109.576 103.611 108.949C104.238 108.322 104.57 107.585 104.57 106.737C104.57 105.889 104.238 105.151 103.611 104.525L93.3243 94.1643C95.5364 90.2192 96.6425 85.463 96.6425 79.8219H107.74C108.588 79.8219 109.326 79.4901 109.953 78.8633C110.579 78.2366 110.911 77.4992 110.911 76.6511C110.911 75.6925 110.616 74.9551 109.989 74.3284Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5214 36.8321C79.4243 33.7351 75.7005 32.1865 71.313 32.1865C66.9255 32.1865 63.2016 33.7351 60.1046 36.8321C57.0075 39.9292 55.459 43.653 55.459 48.0405H87.167C87.167 43.653 85.6185 39.8923 82.5214 36.8321Z",
    fill: "#98A2B3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9267)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.3153,
    cy: 70.9999,
    r: 61.3872,
    stroke: "#98A2B3",
    strokeWidth: 4.07895
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9267",
    x: 31.7148,
    y: 32.1865,
    width: 79.1973,
    height: 79.3528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9267",
    x: 7.88867,
    y: 7.57324,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9267",
    x1: 23.0363,
    y1: 16.5666,
    x2: 124.566,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBug);
export default __webpack_public_path__ + "static/media/IconBug.97e3ce013071a7950c7f0d2f150925ad.svg";
export { ForwardRef as ReactComponent };